import { render, staticRenderFns } from "./AudienceAssignBehaviour.vue?vue&type=template&id=8cf07a0c"
import script from "./AudienceAssignBehaviour.vue?vue&type=script&lang=js"
export * from "./AudienceAssignBehaviour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports